import { cx } from '@linaria/core';
import { useRef } from 'react';
import { item } from './item.style.js';
import { jsx } from 'react/jsx-runtime';

const sliderItemCls = "dibsl41gob";
const sliderItemSelector = `.${sliderItemCls}`;
function SliderItem(props) {
  const ref = useRef(null);
  const isAtLeftEdge = props.infinite ? props.item.offsetIndex % props.pagination.itemsPerPage === 0 : props.pagination.activeItemIndex - props.item.offsetIndex > 0;
  const isAtRightEdge = props.infinite ? props.item.offsetIndex % props.pagination.itemsPerPage === props.pagination.itemsPerPage - 1 : props.pagination.activeItemIndex - props.item.offsetIndex < 0;
  const isVisible = props.item.offsetIndex >= props.pagination.activeItemIndex - (props.pagination.itemsPerPage - 1) / 2 && props.item.offsetIndex <= props.pagination.activeItemIndex + (props.pagination.itemsPerPage - 1) / 2;
  return /*#__PURE__*/jsx("li", {
    ref: ref,
    className: cx(item, !props.disabled && sliderItemCls),
    "data-left": isAtLeftEdge,
    "data-right": isAtRightEdge,
    "data-center": !isAtLeftEdge && !isAtRightEdge,
    children: props.children(props.item, {
      index: props.item.index,
      disabled: props.disabled,
      isVisible,
      location: isAtLeftEdge ? "left" : isAtRightEdge ? "right" : "center"
    })
  });
}

export { SliderItem, sliderItemSelector };
import "./item.linaria.module.css";
//# sourceMappingURL=item.js.map
